import { useSuspenseQuery } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { AccountOverview } from '@/components/accounts/AccountOverview'
import { accountQuery, sessionQuery } from '@/lib/queries'
import { isStaff } from '@/lib/viewer'

/**
 * The account's Home — the landing when you enter an account, and a customer-facing surface (see
 * AccountOverview). Deliberately bare for now: a brand-tinted welcome and the account's reports.
 *
 * Its sub-accounts and settings are their OWN page (`/settings`), not folded in here — Home is a
 * product surface in its own right, settings is management, and the two shouldn't share a screen.
 */
export const Route = createFileRoute('/app/accounts/$accountId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(accountQuery(params.accountId)),
  component: AccountHomePage,
})

function AccountHomePage() {
  const { accountId } = Route.useParams()
  const { data: account } = useSuspenseQuery(accountQuery(accountId))
  const { data: session } = useSuspenseQuery(sessionQuery)

  return (
    <div className="flex flex-col gap-6">
      {/* Only staff can browse the cross-account Accounts list; for a customer this link just bounces
          back to their own account, so it's theirs to see only. */}
      {isStaff(session.user) && (
        <Link
          to="/app/accounts"
          className="flex w-fit items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ChevronLeft className="size-3.5" />
          Accounts
        </Link>
      )}
      <AccountOverview account={account} />
    </div>
  )
}
